import { getConditionalObject } from 'utils/data';

export class LendersMappingsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getOptimalBlueInvestors({ userId = null, companyId }) {
    return this.#http.get('/api/optimal-blue/investors', {
      params: { userId, ...getConditionalObject(companyId, () => ({ companyId })) },
    });
  }

  async getLoanSifterInvestors({ userId = null }) {
    return this.#http.get('/api/loan-sifter/investors', { params: { userId } });
  }

  async getLendersMappings({ pricingEngine, companyId }) {
    return this.#http.get(
      `/api/remote-lender-mapping/pricing-engine/${pricingEngine}`,
      getConditionalObject(companyId, () => ({ params: { companyId } })),
    );
  }

  async putLendersMappings({ pricingEngine, companyId, ...body }) {
    return this.#http.put(
      `/api/remote-lender-mapping/pricing-engine/${pricingEngine}`,
      body,
      getConditionalObject(companyId, () => ({ params: { companyId } })),
    );
  }
}
